export const shorterAddress = (address: string, charactersBeforeToShow?: number): string => {
  return address?.length > 30
    ? `${address.slice(0, charactersBeforeToShow || 21)}...${address.slice(-4)}`
    : address
}
